import { uniqueId } from "@/views/zhiji/js/common/util.js";
import { ParamError } from "@/views/zhiji/js/common/errors.js";
import i18n from "@/i18n";

export default {
    widgetName: "PlatTextLink",
    serverType: "text",
    initContent() {
        return {
            uId: uniqueId(),
            updateState: "add",
            wtType: "PlatTextLink",
            text: "",
            linkWord: [],
            cmd: [],
            cmdTagClassify: []
        };
    },
    checkContent(content) {
        if (!content.text) {
            throw new ParamError(i18n.t("zhiji.answer.textWidget.noTextTip"));
        }
    },
    server2Client(content) {
        let textCvt = transText2Slient(content);
        return {
            uId: uniqueId(),
            wtType: "PlatTextLink",
            text: textCvt.textStr, //TODO 转换成{{xxx}}格式的文本
            updateState: "",
            linkWord: textCvt.linkWords || [],
            cmd: content.cmd
                ? content.cmd.map(item => ({
                      key: item.key,
                      paramId: item.param_id,
                      source: item.source
                  }))
                : [],
            cmdTagClassify: content.cmd_tag_classify
                ? content.cmd_tag_classify.map(item => ({
                      key: item.key,
                      paramId: item.param_id,
                      source: item.source
                  }))
                : []
        };
    },
    client2Server(content) {
        let textServe = transLinkWord2Server(content);
        return {
            type: "text",
            text: textServe.textStr,
            url: "",
            link_word: textServe.linkWords,
            url_type: "",
            cmd: content.cmd
                ? content.cmd.map(item => ({
                      key: item.key,
                      param_id: item.paramId,
                      source: item.source
                  }))
                : [],
            cmd_tag_classify: content.cmdTagClassify
                ? content.cmdTagClassify.map(item => ({
                      key: item.key,
                      param_id: item.paramId,
                      source: item.source
                  }))
                : []
        };
    }
};

// link_word数组转服务端格式 TODO 暂时支持老协议
export function transLinkWord2Server(content) {
    let textStr = content.text;
    let linkWords = [];
    content.linkWord.forEach(item => {
        linkWords.push({
            word: item.word,
            question_id: item.questionId || "",
            link_type: item.type == "link" ? item.linkType : item.type,
            url: item.url || "",
            question: item.question || ""
        });

        textStr = textStr.replace(`{{${item.id}}}`, item.word);
    });
    return {
        textStr,
        linkWords
    };
}

// {{xxx}}格式文本转换
export function transText2Slient(content) {
    let textStr = content.text;
    let linkWords = [];
    content.link_word.forEach(item => {
        let newId = uniqueId();
        let htmlTemplate = `{{${newId}}}`;
        linkWords.push({
            id: newId,
            word: item.word,
            questionId: item.question_id || "",
            type: item.link_type,
            linkType: item.link_type,
            url: item.url,
            question: item.question || ""
        });

        textStr = textStr.replace(item.word, htmlTemplate);
    });
    return {
        textStr,
        linkWords
    };
}
